$(window).load(function() {
    'use strict';

    var offsets = [],
        offset_cur,
        top_max = 0,
        $img_cur;

    if (document.documentElement.clientWidth > 960) {
        $('.section-blog-navigation .recent-post-item img').each(function(i, child) {
            offset_cur = $(child).offset();
            offsets.push(offset_cur);
            if(offset_cur.top > top_max){
                top_max = offset_cur.top;
            }
        });

        $('.section-blog-navigation .recent-post-item').find('img').each(function(i, child) {
            $(child).offset({
                top: top_max,
                left: offsets[i].left
            })
        });
    }
});
